import { Component, Inject, OnInit } from '@angular/core'
import {
	MAT_DIALOG_DATA,
	MatDialog,
	MatDialogRef,
} from '@angular/material/dialog'
import { PayoutService } from '../../services/payout.service'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { ImageUpload } from 'src/app/shared/models/general.models'
import { UploadImageComponent } from 'src/app/shared/components/upload-image/upload-image.component'
import { Subscription } from 'rxjs'
import { TranslateService } from '@ngx-translate/core'
import { clientPayout, payoutDetatilsModel } from '../../models/client-payout'
import { environment } from 'src/environments/environment'

@Component({
	selector: 'app-accept-reject-client-payout-popup',
	templateUrl: './accept-reject-client-payout-popup.component.html',
	styleUrls: ['./accept-reject-client-payout-popup.component.scss'],
})
export class AcceptRejectClientPayoutPopupComponent implements OnInit {
	formData: FormGroup = new FormGroup({})
	subscription = new Subscription()
	formControl: any
	imgConfig: ImageUpload = {
		imageCropDimensions: 2.1,
		imageWidth: 800,
		imageHeight: 500,
	}
	accept = true
	reject = false
	attachmentUrl = environment.attachmentPath
	clientData!: clientPayout
	constructor(
		public dialog: MatDialogRef<AcceptRejectClientPayoutPopupComponent>,
		@Inject(MAT_DIALOG_DATA) public data: payoutDetatilsModel,
		private dialogO: MatDialog,
		private payoutService: PayoutService,
		public translate: TranslateService
	) {
		this.clientData = data.clientData
	}

	ngOnInit(): void {
		this.initForm()

		this.onChange()
	}
	initForm() {
		this.formData = new FormGroup({
			notes: new FormControl(null),
			image: new FormControl(null, [Validators.required]),
			amount: new FormControl({
				value: this.clientData?.requestedAmount,
				disabled: true,
			}),
		})
	}
	closeDialog() {
		this.dialog.close()
	}
	onChange() {
		this.initForm()
		if (this.reject && !this.accept) {
			this.getController('notes').addValidators(Validators.required)
			this.getController('notes').updateValueAndValidity()
			this.getController('image').removeValidators(Validators.required)
			this.getController('image').updateValueAndValidity()
		} else {
			this.getController('notes').removeValidators(Validators.required)
			this.getController('notes').updateValueAndValidity()
			this.getController('image').addValidators(Validators.required)
			this.getController('image').updateValueAndValidity()
		}
	}
	uploadImage() {
		this.dialogO
			.open(UploadImageComponent, {
				width: '752px',
				panelClass: 'overflow-y-auto',
				data: this.imgConfig,
				autoFocus: false,
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						const body = new FormData()
						body.append('image', res.selectedFile)
						this.subscription.add(
							this.payoutService
								.UploadclientPayoutImage(body)
								.subscribe((res: any) => {
									this.getController('image')?.setValue(res?.result?.url)
								})
						)
					}
				},
			})
	}

	getController(controlName: string) {
		return this.formData.controls[controlName] as FormControl
	}
	confirm() {
		this.dialog.close({ ...this.formData.getRawValue(), type: this.accept })
	}
}
